import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Ecart from "../../assets/images/new/e-cart.jpg";

import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import panditIcon from "../../assets/images/new/Pandit.png";
import templeIcon from "../../assets/images/new/Temple.png";
import pujaIcon from "../../assets/images/new/Pooja.png";
import estoreIcon from "../../assets/images/new/E-store.png";
import groupIcon from "../../assets/images/new/Group 1000004477.png";

import pujaBookingServiceImg from "../../assets/images/new/PujaBookingService.png";
import dailyBookingServiceImg from "../../assets/images/new/DailyPujaBookingService.png";
import darshanBookingServiceImg from "../../assets/images/new/DarshanBookingService.png";
import templePujaServiceImg from "../../assets/images/new/PujaAtTempleService.png";
import horoscopeServiceImg from "../../assets/images/new/HoroscopeService.png";
import homam from "../../assets/images/new/Homa.jpeg";
import Pandit from "../../assets/images/new/PanditImag.jpeg";
import DailyPanditHome from "../../assets/images/new/DailyPanditHom.jpeg";
import Temple from "../../assets/images/new/TempleImage.png";
import { t } from "i18next";
import { AuthContextProvider } from "../../AuthContext/AuthContext";
import LoginPopUp from "../LoginPopup";



const BestServices = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContextProvider);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const services = [
    // Remedy puja
    {
      key: 2,
      title: t("Remedy Puja"),
      image: pujaBookingServiceImg,
      serviceIcon: panditIcon,
      icon: "https://www.vedicyatras.com/assets/front/images/kumbhmela.svg",
      text: t("Book Remedy Puja to Experience Peace."),
      color: "#ffa415",
      route: "/remedy-puja",
      ctaName: t('Book Now')
    },
    // Homam Puja
    {
      key: 3,
      title: t("Homam"),
      image: homam,
      serviceIcon: pujaIcon,
      icon: "https://www.vedicyatras.com/assets/front/images/kumbhmela.svg",
      text: t("Feel divine presence with Homam Puja."),
      color: "#fc5528",
      route: "/homam-puja",
      ctaName: t('Book Now')
    },
    // Pandit Service
    {
      key: 0,
      title: t("Pandit"),
      image: Pandit,
      serviceIcon: templeIcon,
      icon: "https://www.vedicyatras.com/assets/front/images/kumbhmela.svg",
      text: t("Book experienced Pandits for your puja and ceremonies."),
      route: "/pandit-puja",
      ctaName: t('Book Now')
    },
    // Daily Pandit Puja
    {
      key: 1,
      title: t("Daily Pandit (Puja)"),
      image: DailyPanditHome,
      serviceIcon: templeIcon,
      icon: "https://www.vedicyatras.com/assets/front/images/kumbhmela.svg",
      text: t("Book a Pandit for your daily morning and evening pujas."),
      route: "/daily-pandit-puja",
      ctaName: t('Book Now')
    },



    // {
    //   key: 2,
    //   title: "Darshan Booking",
    //   image: darshanBookingServiceImg,
    //   serviceIcon: batuk,
    //   icon: "https://www.vedicyatras.com/assets/front/images/kumbhmela.svg",
    //   text: "Easily book darshans at temples across India.",
    //   route: "/services/darshan-booking",
    //   ctaName: 'Book Now'
    // },
    // {
    //   key: 4,
    //   title: "Temple",
    //   image: Temple,
    //   serviceIcon: groupIcon,
    //   icon: "https://www.vedicyatras.com/assets/front/images/kumbhmela.svg",
    //   text: "Get Temples details and their best services",
    //   color: "#d340c3",
    //   route: "/temple",
    //   ctaName: 'Visit Now'
    // },

    // E-Store Service
    {
      key: 5,
      title: t("E-Store"),
      image: Ecart,
      serviceIcon: estoreIcon,
      icon: "https://www.vedicyatras.com/assets/front/images/kumbhmela.svg",
      text: t("Shop authentic puja samgari, puja kit and puja essentials online in our E-store."),
      color: "#8139e7",
      route: "/services/e-store",
      ctaName: t('Shop Now')
    },
    // Astrology Service
    {
      key: 6,
      title: t("Astrology"),
      image: horoscopeServiceImg,
      serviceIcon: groupIcon,
      icon: "https://www.vedicyatras.com/assets/front/images/kumbhmela.svg",
      text: t("Get accurate horoscope readings and astrology guidance."),
      color: "#d340c3",
      route: "/horoscope-detail",
      ctaName: t('Consult Now')
    },

    // {
    //   key: 7,
    //   title: "Chadhava",
    //   image: templePujaServiceImg,
    //   serviceIcon: templeIcon,
    //   icon: "https://www.vedicyatras.com/assets/front/images/kumbhmela.svg",
    //   text: "You can do puja in the temple by booking our Pandit.",
    //   route: "#",
    //   ctaName: 'Offer Now'
    // },
    // {
    //   key: 8,
    //   title: "Remedy Tourism",
    //   image: templePujaServiceImg,
    //   serviceIcon: templeIcon,
    //   icon: "https://www.vedicyatras.com/assets/front/images/kumbhmela.svg",
    //   text: "You can do puja in the temple by booking our Pandit.",
    //   route: "#",
    //   ctaName: 'Enquire  Now'
    // },
    // {
    //   key: 9,
    //   title: "Roots",
    //   image: templePujaServiceImg,
    //   serviceIcon: templeIcon,
    //   icon: "https://www.vedicyatras.com/assets/front/images/kumbhmela.svg",
    //   text: "You can do puja in the temple by booking our Pandit.",
    //   route: "#",
    //   ctaName: 'Enquire  Now'
    // },


  ];

  const HandleRoute = (service) => {

    if (service?.route === "/horoscope-detail") {
      if (isAuthenticated) {
        navigate(service?.route, { state: { key: service.key } })
      } else {
        setShowLoginModal(true);
      }
    } else {
      navigate(service?.route, { state: { key: service.key } })
    }
  }
  return (
    <>
      <section className="service-two">
        <div className="service-two__shape"></div>
        <div
          className="container"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div className="section-title text-center">
            <h6
              className="sec-title__tagline bw-split-in-right"

            >
              <img className="tagline-img" src={batuk} alt="" />
              {t("Best Services")}
            </h6>
            <h2
              className="sec-title__title bw-split-in-left"
              style={{ textAlign: "center", marginTop: "7px" }}
            >
              {/* Book Puja Services At your Fingertips */}
              {t("Your One-Stop Destination for Spiritual Services")}
            </h2>
          </div>
          <div className="row gutter-y-30 custom-gutter bestServices-Responsive-card justify-content-left" >
            {services.map((service, index) => (
              <div
                key={index}
                style={{ cursor: "pointer" }}
                className="col-lg-4 col-md-6 wow fadeInUp"
                data-wow-delay={`${index * 100}ms`}
                onClick={() => {
                  HandleRoute(service)
                  window.scrollTo({ top: 0, behavior: "instant" }); // Instantly move to the top without scroll animation
                }}
              >
                <div
                  className="service-two__item text-center"
                  // style={{ "--accent-color": service.color }}
                  style={{ color: "black", padding: '0px' }}
                >
                  <div
                    className="service-two__item__shape"
                  // style={{
                  //   backgroundImage: "url(assets/images/new/leftside.png)",
                  // }}
                  ></div>
                  <div className="service-two__item__image">
                    <img
                      src={service.image}
                      alt="MyOm Namo"
                      className="servimgsize"
                      style={{ width: "342px", objectFit: "cover", marginTop: "10px" }}
                    />
                  </div>
                  <div className="service-two__item__icon">
                    <img
                      src={Batuk}
                      alt=""
                      className="service_i"
                      style={{ borderRadius: "50%" }}
                    />
                  </div>
                  <h3
                    className="service-two__item__title"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {service.title}
                  </h3>
                  <p
                    className="service-two__item__text"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      height: '5em'
                    }}
                  // style={{ color: "black" }}
                  >
                    {service.text}
                  </p>
                  <div className="service-two__item__rm" onClick={() => HandleRoute(service)}>
                    {/* Navigate to the respective route */}
                    <Link >{service?.ctaName}</Link>
                    <i className="icon-right-arrow"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section >
      {
        showLoginModal && (
          <LoginPopUp
            show={showLoginModal}
            onHide={() => setShowLoginModal(false)}
            setOnGetOTP={() => setShowLoginModal(false)}
          />
        )
      }
    </>

  );
};

export default BestServices;
